import React from 'react';
import { Input } from 'antd';
import type { PartyFeature } from '../../types/types';
import EditableListManager from './EditableListManager';
import styles from './EditableListManager.module.css';

const { TextArea } = Input;

interface FeatureManagerProps {
  items: PartyFeature[];
  onChange: (newItems: PartyFeature[] | ((prevItems: PartyFeature[]) => PartyFeature[])) => void;
}

const FeatureManager: React.FC<FeatureManagerProps> = (props) => {
  return (
    <EditableListManager<PartyFeature>
      {...props}
      defaultNewItem={() => ({
        name: '',
        description: '',
        partyMemberId: 0, // This will be updated on save        
        updatedAt: new Date(),
      })}
      addText="Add Feature"
      renderItemFields={(item, index, handleItemChange) => (
        <div className={styles.itemFields} style={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <Input
            placeholder="Feature Name"
            value={item.name}
            onChange={(e) => handleItemChange(index, { name: e.target.value })}
          />
          <TextArea
            placeholder="Description"
            value={item.description ?? ''}
            onChange={(e) => handleItemChange(index, { description: e.target.value })}
            autoSize={{ minRows: 2 }}
          />
        </div>
      )}
    />
  );
};

export default FeatureManager;